<script lang="ts">
  import { ui, patch } from '../game/store.ts';
  import { t } from '../i18n.ts';
  import { feature } from '../../shared/features.ts';
  let { onMenu }: { onMenu: () => void } = $props();
  // Kapitelende → nächstes Kapitel anbieten (ch1 → ch2 …), falls vorhanden
  const m = $derived(/^ch(\d+)$/.exec($ui.ended ?? ''));
  let next = $state<string | null>(null);
  $effect(() => {
    const id = m ? 'ch' + (Number(m[1]) + 1) : null;
    next = null;
    if (!id || !feature.editor) return;
    fetch('/api/chapters')
      .then((r) => r.json())
      .then((list: { id: string }[]) => (next = list.some((c) => c.id === id) ? id : null))
      .catch(() => {});
  });
</script>

<div class="end" role="dialog" aria-modal="true" data-testid="end-card">
  <div class="panel card">
    <span class="kicker">{t('end.kicker')}</span>
    <h2>{t(`end.${$ui.ended}.title`)}</h2>
    <p>{t(`end.${$ui.ended}.text`)}</p>
    <div class="row">
      <button class="btn" onclick={() => patch({ ended: null })}>{t('end.stay')}</button>
      {#if $ui.ended === 's1'}
        <button class="btn primary" onclick={() => patch({ ended: null, show: true })} data-testid="end-show">{t('end.startShow')}</button>
      {/if}
      {#if next}
        <a class="btn primary" href={'/?chapter=' + next} data-testid="end-next">{t('end.next')}</a>
      {/if}
      <button class="btn primary" onclick={() => { patch({ ended: null }); onMenu(); }}>{t('end.menu')}</button>
    </div>
  </div>
</div>

<style>
  .end { position: fixed; inset: 0; display: grid; place-items: center; padding: 16px; z-index: 38; background: rgba(12,20,34,.6); }
  .card { width: min(480px, 100%); padding: 26px; text-align: center; animation: rise .6s ease both; }
  @keyframes rise { from { opacity: 0; transform: translateY(12px); } }
  .kicker { font-family: var(--font-hand); font-size: 1.5rem; color: var(--amber2); }
  h2 { font-family: var(--font-display); color: var(--amber3); font-size: 2rem; margin: 6px 0 10px; }
  p { line-height: 1.5; color: var(--paper); }
  .row { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin-top: 16px; }
</style>
